export function copy(extension) {
    return extension;
}
export default copy;
//# sourceMappingURL=copy.js.map